export default __webpack_public_path__ + "static/media/queen_of_pentacles.92d7dcf8.png";